export default {
  contestList: [],
  contestDetails: null
}
